/* Minimaler Upsell-Interceptor für Athens.
   - Patcht fetch und XHR.
   - Wenn ein POST auf /cart/add(.js) OHNE "items" geht und es eine Upsell-Variant-ID gibt,
     wird der Body auf ein kombiniertes "items"-Payload umgeschrieben.
   - Keine Drawer-Opens. Keine Events. Keine Redirect-Blocker.
*/

(function() {
  // ---------- Helpers ----------
  function isAddToCartURL(url) {
    try {
      var u = typeof url === 'string' ? new URL(url, location.origin) : new URL(url && url.url || '', location.origin);
      return /\/cart\/add(\.js)?$/.test(u.pathname);
    } catch { return false; }
  }

  function findUpsellRoot(scope) {
    return (scope && scope.querySelector('.upsell-selector[data-upsell-variant-id]')) ||
           document.querySelector('.upsell-selector[data-upsell-variant-id]') ||
           (scope && scope.querySelector('.upsell-item[data-upsell-variant-id]')) ||
           document.querySelector('.upsell-item[data-upsell-variant-id]');
  }

  // Checkbox ist optional. Wenn vorhanden und nicht angehakt: kein Upsell.
  function getUpsellVariantId(scope) {
    var root = findUpsellRoot(scope);
    if (!root) return null;

    var cb = root.querySelector('input[name="add_upsell"]');
    if (cb && !cb.checked) return null;

    var vid = parseInt(root.getAttribute('data-upsell-variant-id'), 10);
    if (!vid || isNaN(vid)) {
      var hid = root.querySelector('input[name="upsell_variant_id"]');
      if (hid && hid.value) vid = parseInt(hid.value, 10);
    }
    return (vid && !isNaN(vid)) ? vid : null;
  }

  function getMainFormQuantity() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var q = form.querySelector('[name="quantity"]');
    var val = q && q.value ? parseInt(q.value, 10) : 1;
    return isNaN(val) || val < 1 ? 1 : val;
  }

  function getMainFormProperties() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return {};
    var out = {};
    form.querySelectorAll('[name^="properties["]').forEach(function(inp){
      var m = inp.name.match(/^properties\[(.+)\]$/);
      if (m) out[m[1]] = inp.value;
    });
    return out;
  }

  // ---------- fetch Patch ----------
  if (!window.__UPS_FETCH_PATCHED_MIN__) {
    window.__UPS_FETCH_PATCHED_MIN__ = true;

    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && (init.method || (init.headers && init.headers['x-http-method-override']))) || 'GET';

        if (isAddToCartURL(url) && String(method).toUpperCase() === 'POST') {
          var upsellVid = getUpsellVariantId(document);
          if (upsellVid && init && init.body) {
            var ct = (init.headers && (init.headers['Content-Type'] || init.headers['content-type'])) || '';

            // JSON-Body
            if (typeof init.body === 'string' && ct.indexOf('application/json') !== -1) {
              try {
                var data = JSON.parse(init.body);
                if (!data.items && data.id) {
                  var qty = typeof data.quantity === 'number' ? data.quantity : (getMainFormQuantity() || 1);
                  var props = getMainFormProperties();
                  var items = [{ id: data.id, quantity: qty }];
                  if (props && Object.keys(props).length) items[0].properties = props;

                  if (Number(upsellVid) !== Number(data.id)) {
                    items.push({ id: upsellVid, quantity: 1 });
                  } else {
                    items[0].quantity = Number(items[0].quantity) + 1;
                  }
                  // Content-Type unverändert lassen
                  init.body = JSON.stringify({ items: items });
                }
              } catch(e) {}
            }
            // URL-encoded
            else if (typeof init.body === 'string' && ct.indexOf('application/x-www-form-urlencoded') !== -1) {
              var p = new URLSearchParams(init.body);
              var hasItems = Array.from(p.keys()).some(function(k){ return k.startsWith('items['); });
              var mainId = p.get('id');
              if (!hasItems && mainId) {
                var qty2 = p.get('quantity') ? parseInt(p.get('quantity'), 10) : (getMainFormQuantity() || 1);
                var props2 = getMainFormProperties();

                var p2 = new URLSearchParams();
                p2.set('items[0][id]', String(mainId));
                p2.set('items[0][quantity]', String(isNaN(qty2) || qty2 < 1 ? 1 : qty2));
                Object.keys(props2).forEach(function(key){ p2.set('items[0][properties]['+key+']', props2[key]); });

                if (Number(upsellVid) !== Number(mainId)) {
                  p2.set('items[1][id]', String(upsellVid));
                  p2.set('items[1][quantity]', '1');
                } else {
                  var newQty = (isNaN(qty2) || qty2 < 1 ? 1 : qty2) + 1;
                  p2.set('items[0][quantity]', String(newQty));
                }
                // Header wie geliefert beibehalten
                init.body = p2.toString();
              }
            }
            // FormData
            else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
              var fd = init.body;
              var hasItemsFD = Array.from(fd.keys()).some(function(k){ return k.startsWith('items['); });
              var mainIdFD = fd.get('id');
              if (!hasItemsFD && mainIdFD) {
                var qty3 = fd.get('quantity') ? parseInt(fd.get('quantity'), 10) : (getMainFormQuantity() || 1);
                var props3 = getMainFormProperties();

                // Originalfelder entfernen und als items auffüllen
                fd.delete('id'); fd.delete('quantity');
                fd.append('items[0][id]', String(mainIdFD));
                fd.append('items[0][quantity]', String(isNaN(qty3) || qty3 < 1 ? 1 : qty3));
                Object.keys(props3).forEach(function(key){ fd.append('items[0][properties]['+key+']', props3[key]); });

                if (Number(upsellVid) !== Number(mainIdFD)) {
                  fd.append('items[1][id]', String(upsellVid));
                  fd.append('items[1][quantity]', '1');
                } else {
                  // FormData kann bestehende quantity nicht ersetzen, aber hier passt es,
                  // weil wir bereits items[0][quantity] gesetzt haben.
                }
              }
            }
          }
        }
      } catch(e) {}
      return origFetch.apply(this, arguments);
    };
  }

  // ---------- XHR Patch ----------
  if (!window.__UPS_XHR_PATCHED_MIN__) {
    window.__UPS_XHR_PATCHED_MIN__ = true;

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__ups_method = method;
      this.__ups_url = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      try {
        if (isAddToCartURL(this.__ups_url) && String(this.__ups_method).toUpperCase() === 'POST') {
          var upsellVid = getUpsellVariantId(document);
          if (upsellVid) {
            var ct = (this._headers && (this._headers['Content-Type'] || this._headers['content-type'])) || '';

            // JSON
            if (body && typeof body === 'string' && ct.indexOf('application/json') !== -1) {
              try {
                var data = JSON.parse(body);
                if (!data.items && data.id) {
                  var qty = typeof data.quantity === 'number' ? data.quantity : (getMainFormQuantity() || 1);
                  var props = getMainFormProperties();
                  var items = [{ id: data.id, quantity: qty }];
                  if (props && Object.keys(props).length) items[0].properties = props;

                  if (Number(upsellVid) !== Number(data.id)) {
                    items.push({ id: upsellVid, quantity: 1 });
                  } else {
                    items[0].quantity = Number(items[0].quantity) + 1;
                  }
                  body = JSON.stringify({ items: items }); // Content-Type bleibt wie gesetzt
                }
              } catch(e) {}
            }
            // URL-encoded
            else if (body && typeof body === 'string' && ct.indexOf('application/x-www-form-urlencoded') !== -1) {
              var p = new URLSearchParams(body);
              var hasItems = Array.from(p.keys()).some(function(k){ return k.startsWith('items['); });
              var mainId = p.get('id');
              if (!hasItems && mainId) {
                var qty2 = p.get('quantity') ? parseInt(p.get('quantity'), 10) : (getMainFormQuantity() || 1);
                var props2 = getMainFormProperties();

                var p2 = new URLSearchParams();
                p2.set('items[0][id]', String(mainId));
                p2.set('items[0][quantity]', String(isNaN(qty2) || qty2 < 1 ? 1 : qty2));
                Object.keys(props2).forEach(function(key){ p2.set('items[0][properties]['+key+']', props2[key]); });

                if (Number(upsellVid) !== Number(mainId)) {
                  p2.set('items[1][id]', String(upsellVid));
                  p2.set('items[1][quantity]', '1');
                } else {
                  var newQty = (isNaN(qty2) || qty2 < 1 ? 1 : qty2) + 1;
                  p2.set('items[0][quantity]', String(newQty));
                }
                body = p2.toString(); // Header bleibt wie gesetzt
              }
            }
            // FormData
            else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
              var hasItemsFD = Array.from(body.keys()).some(function(k){ return k.startsWith('items['); });
              var mainIdFD = body.get('id');
              if (!hasItemsFD && mainIdFD) {
                var qty3 = body.get('quantity') ? parseInt(body.get('quantity'), 10) : (getMainFormQuantity() || 1);
                var props3 = getMainFormProperties();

                body.delete('id'); body.delete('quantity');
                body.append('items[0][id]', String(mainIdFD));
                body.append('items[0][quantity]', String(isNaN(qty3) || qty3 < 1 ? 1 : qty3));
                Object.keys(props3).forEach(function(key){ body.append('items[0][properties]['+key+']', props3[key]); });

                if (Number(upsellVid) !== Number(mainIdFD)) {
                  body.append('items[1][id]', String(upsellVid));
                  body.append('items[1][quantity]', '1');
                }
              }
            }
          }
        }
      } catch(e) {}
      return origSend.call(this, body);
    };

    // Content-Type für send() merkbar machen
    var origSetHeader = XMLHttpRequest.prototype.setRequestHeader;
    XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
      this._headers = this._headers || {};
      this._headers[name] = value;
      return origSetHeader.call(this, name, value);
    };
  }
})();

// --- Upsell-Auswahl synchronisieren (inkl. „Ohne Speicher“) ---
(function(){
  function q(sel, root){ return (root||document).querySelector(sel); }
  function closest(el, sel){ while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; } return null; }

  function setSelectedVariant(root, vid) {
    if (!root) return;
    if (vid) {
      root.setAttribute('data-upsell-variant-id', String(vid));
      var hid = root.querySelector('input[name="upsell_variant_id"]');
      if (hid) hid.value = String(vid);
    } else {
      root.removeAttribute('data-upsell-variant-id');
      var hid2 = root.querySelector('input[name="upsell_variant_id"]');
      if (hid2) hid2.value = '';
    }
  }

  function initUpsellSelector() {
    var root = q('.upsell-selector');
    if (!root || root.__upsellChoiceBound) return;
    root.__upsellChoiceBound = true;

    // Initial setzen je nach vorselektiertem Radio
    (function primeInitial(){
      var checked = root.querySelector('.upsell-product-radio:checked');
      if (!checked) return;
      if (checked.hasAttribute('data-none')) {
        setSelectedVariant(root, null);
        return;
      }
      var card = closest(checked, '.upsell-card') || closest(checked, '.product-recommendation-list-row-item');
      var dd = card && card.querySelector('.upsell-variant-dropdown');
      var vid = dd && dd.value ? dd.value : checked.getAttribute('data-variant-id');
      setSelectedVariant(root, vid || null);
    })();

    root.addEventListener('change', function(e){
      // Radio geklickt
      if (e.target && e.target.classList && e.target.classList.contains('upsell-product-radio')) {
        if (!e.target.checked) return;
        if (e.target.hasAttribute('data-none')) {
          setSelectedVariant(root, null);
          return;
        }
        var card = closest(e.target, '.upsell-card') || closest(e.target, '.product-recommendation-list-row-item');
        var dd = card && card.querySelector('.upsell-variant-dropdown');
        var vid = dd && dd.value ? dd.value : e.target.getAttribute('data-variant-id');
        setSelectedVariant(root, vid || null);
        return;
      }
      // Dropdown geändert
      if (e.target && e.target.classList && e.target.classList.contains('upsell-variant-dropdown')) {
        var card = closest(e.target, '.upsell-card') || closest(e.target, '.product-recommendation-list-row-item');
        var r = card && card.querySelector('.upsell-product-radio');
        if (r) r.checked = true; // Karte aktivieren
        setSelectedVariant(root, e.target.value || null);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellSelector);
  } else {
    initUpsellSelector();
  }
  document.addEventListener('shopify:section:load', initUpsellSelector);
  document.addEventListener('page:load', initUpsellSelector);
})();